import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const Container = styled(Box, {
  name: 'Container',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro';
  font-size: 14px;
  line-height: 30px;
  padding-bottom: 24px;
`
